import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const FAQSection = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = t('faq.questions', { returnObjects: true });

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 px-4 bg-slate-50">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center">
          {t('faq.title')}
        </h2>
        <div className="w-20 h-1 mx-auto mb-4" style={{ backgroundColor: 'var(--medical-primary)' }}></div>
        <p className="text-center text-slate-600 mb-12 text-lg">
          {t('faq.subtitle')}
        </p>

        <div className="space-y-4">
          {faqs.map((faq) => (
            <Card key={faq.q} className="border-0 shadow-md hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-0">
                <button
                  onClick={() => toggleFAQ(faq.q)}
                  className="w-full text-left p-6 flex justify-between items-center"
                  aria-expanded={openIndex === faq.q}
                >
                  <h3 className="text-lg font-semibold text-slate-900 pr-4">
                    {faq.q}
                  </h3>
                  {openIndex === faq.q ? (
                    <ChevronUp className="flex-shrink-0" style={{ color: 'var(--medical-primary)' }} size={24} />
                  ) : (
                    <ChevronDown className="flex-shrink-0 text-slate-400" size={24} />
                  )}
                </button>
                
                {openIndex === faq.q && (
                  <div className="px-6 pb-6">
                    <p className="text-slate-700 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-700 mb-4">
            {t('faq.moreQuestions')}
          </p>
          <a 
            href="tel:+919552374093"
            className="inline-flex items-center px-6 py-3 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105"
            style={{ backgroundColor: 'var(--medical-primary)' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--medical-primary-hover)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--medical-primary)'}
          >
            {t('faq.callNow')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
